"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.USER_ROLES = void 0;
exports.USER_ROLES = {
    ADMIN: {
        id: 1,
        name: 'Admin',
    },
    MANAGER: {
        id: 2,
        name: 'Manager',
    },
    STAFF: {
        id: 3,
        name: 'Staff',
    },
};
//# sourceMappingURL=user-roles.types.js.map